module.exports = __webpack_public_path__ + "8b84f9e561dce317ac46a60566d35fa2.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/uneven-s.png
// module id = 2241
// module chunks = 0